
const DELIVERY_COUNTRY = {

  AUSTRIA: { fullName: "Oostenrijk", sourceCode: "AT", iso2: "AT", iso3: "AUT" },
  BELGIUM: { fullName: "België", sourceCode: "B", iso2: "BE", iso3: "BEL" },
  SWITZERLAND: { fullName: "Zwitserland", sourceCode: "CH", iso2: "CH", iso3: "CHE" },
  CZECHIA: { fullName: "Tsjechië", sourceCode: "CZ", iso2: "CZ", iso3: "CZE" },
  GERMANY: { fullName: "Duitsland", sourceCode: "DE", iso2: "DE", iso3: "DEU" },
  DENMARK: { fullName: "Denemarken", sourceCode: "DK", iso2: "DK", iso3: "DNK" },
  ENGLAND: { fullName: "England", sourceCode: "ENG", iso2: null, iso3: null },
  FRANCE: { fullName: "Frankrijk", sourceCode: "FR", iso2: "FR", iso3: "FRA" },
  FINLAND: { fullName: "Finland", sourceCode: "FI", iso2: "FI", iso3: "FIN" },
  GUERNSEY: { fullName: "Guernsey Kanaaleilanden", sourceCode: "GG", iso2: "GG", iso3: "GGY" },
  GREECE: { fullName: "Griekenland", sourceCode: "GR", iso2: "GR", iso3: "GRC" },
  HUNGARY: { fullName: "Hongarije", sourceCode: "H", iso2: "HU", iso3: "HUN" },
  CROATIA: { fullName: "Croatië", sourceCode: "HR", iso2: "HR", iso3: "HRV" },
  ITALY: { fullName: "Italië", sourceCode: "IT", iso2: "IT", iso3: "ITA" },
  IRELAND: { fullName: "Rep of Ireland", sourceCode: "IRL", iso2: "IE", iso3: "IRL" },
  ISRAEL: { fullName: "Israel", sourceCode: "ISR", iso2: "IL", iso3: "ISR" },
  JAPAN: { fullName: "Japan", sourceCode: "JAP", iso2: "JP", iso3: "JPN" },
  CONGO: { fullName: "Kongo", sourceCode: "KON", iso2: null, iso3: null },
  LUXEMBOURG: { fullName: "Luxemburg", sourceCode: "LU", iso2: "LU", iso3: "LUX" },
  NORWAY: { fullName: "Noorwegen", sourceCode: "N", iso2: "NO", iso3: "NOR" },
  NETHERLANDS: { fullName: "Nederland", sourceCode: "NL", iso2: "NL", iso3: "NLD" },
  PORTUGAL: { fullName: "Portugal", sourceCode: "PT", iso2: "PT", iso3: "PRT" },
  PAKISTAN: { fullName: "Pakistan", sourceCode: "PAK", iso2: "PK", iso3: "PAK" },
  POLAND: { fullName: "Polen", sourceCode: "PL", iso2: "PL", iso3: "POL" },
  ROMANIA: { fullName: "Roemenië", sourceCode: "RO", iso2: "RO", iso3: "ROU" },
  SWEDEN: { fullName: "Zweden", sourceCode: "S", iso2: "SE", iso3: "SWE" },
  TURKEY: { fullName: "Turkije", sourceCode: "TR", iso2: "TR", iso3: "TUR" },
  UGANDA: { fullName: "Uganda", sourceCode: "UG", iso2: "UG", iso3: "UGA" },
  UNITED_KINGDOM: { fullName: "United Kingdom", sourceCode: "UK", iso2: "GB", iso3: "GBR" },
  UNITED_STATES: { fullName: "United States", sourceCode: "USA", iso2: "US", iso3: "USA" },
  COTE_DIVOIRE: { fullName: "Cote d'Ivoire", sourceCode: "CI", iso2: "CI", iso3: "CIV" },
  SLOVAKIA: { fullName: "Slovakije", sourceCode: "SK", iso2: "SK", iso3: "SVK" },
  CYPRUS: { fullName: "Cyprus", sourceCode: "CY", iso2: "CY", iso3: "CYP" },
  TAIWAN: { fullName: "Taiwan", sourceCode: "TAIWAN", iso2: "TW", iso3: "TWN" },
  CHINA: { fullName: "China", sourceCode: "CN", iso2: "CN", iso3: "CHN" },
  BULGARIA: { fullName: "Bulgaria", sourceCode: "BG", iso2: "BG", iso3: "BGR" },
  SINGAPORE: { fullName: "Singapore", sourceCode: "SG", iso2: "SG", iso3: "SGP" },
  AUSTRALIA: { fullName: "Australië", sourceCode: "AU", iso2: "AU", iso3: "AUS" },
  SLOVENIA: { fullName: "Slovenië", sourceCode: "SI", iso2: "SI", iso3: "SVN" },
  UNITED_ARAB_EMIRATES: { fullName: "Verenigde Arabische Emiraten", sourceCode: "AE", iso2: "AE", iso3: "ARE" },
  SPAIN: { fullName: "Spanje", sourceCode: "ES", iso2: "ES", iso3: "ESP" },
  LATVIA: { fullName: "Letland", sourceCode: "LV", iso2: "LV", iso3: "LVA" },
  ESTONIA: { fullName: "Estland", sourceCode: "EE", iso2: "EE", iso3: "EST" },
  BOSNIA_AND_HERZEGOVINA: { fullName: "Bosnië-Herzegovina", sourceCode: "BA", iso2: "BA", iso3: "BIH" },
  SERBIA: { fullName: "Servië", sourceCode: "RS", iso2: "RS", iso3: "SRB" },
  SOUTH_AFRICA: { fullName: "Zuid Afrika", sourceCode: "ZA", iso2: "ZA", iso3: "ZAF" },
  LITHUANIA: { fullName: "Litouwen", sourceCode: "LT", iso2: "LT", iso3: "LTU" },
  SOUTH_KOREA: { fullName: "Korea", sourceCode: "KOR", iso2: "KR", iso3: "KOR" },
  BRAZIL: { fullName: "Brazilië", sourceCode: "BR", iso2: "BR", iso3: "BRA" },
  GAMBIA: { fullName: "Gambia", sourceCode: "GA", iso2: "GM", iso3: "GMB" },
  COSTA_RICA: { fullName: "Costa Rica", sourceCode: "CR", iso2: "CR", iso3: "CRI" },
  THAILAND: { fullName: "Thailand", sourceCode: "", iso2: "TH", iso3: "THA" },
  UNKNOWN_P: { fullName: "P", sourceCode: "P", iso2: null, iso3: null },
  UNKNOWN_L: { fullName: "L", sourceCode: "L", iso2: null, iso3: null },
  CANADA: { fullName: "Canada", sourceCode: "CA", iso2: "CA", iso3: "CAN" },
  MAURITIUS: { fullName: "Mauritius", sourceCode: "MU", iso2: "MU", iso3: "MUS" }
};

const ALLOWED_COUNTRIES_FOR_REGISTRATION_BY_ISO2 = ["BE", "NL", "FR"]

const ALL_COUNTRIES = {
  AFGHANISTAN: {
    fullName: "Afghanistan",
    twoLetterISOCode: "AF",
    oneLetterDIASCode: "A",
  },
  ALAND_ISLANDS: {
    fullName: "Åland Islands",
    twoLetterISOCode: "AX",
    oneLetterDIASCode: "A",
  },
  ALBANIA: {
    fullName: "Albania",
    twoLetterISOCode: "AL",
    oneLetterDIASCode: "A",
  },
  ALGERIA: {
    fullName: "Algeria",
    twoLetterISOCode: "DZ",
    oneLetterDIASCode: "A",
  },
  AMERICAN_SAMOA: {
    fullName: "American Samoa",
    twoLetterISOCode: "AS",
    oneLetterDIASCode: "A",
  },
  ANDORRA: {
    fullName: "AndorrA",
    twoLetterISOCode: "AD",
    oneLetterDIASCode: "A",
  },
  ANGOLA: {
    fullName: "Angola",
    twoLetterISOCode: "AO",
    oneLetterDIASCode: "A",
  },
  ANGUILLA: {
    fullName: "Anguilla",
    twoLetterISOCode: "AI",
    oneLetterDIASCode: "A",
  },
  ANTARCTICA: {
    fullName: "Antarctica",
    twoLetterISOCode: "AQ",
    oneLetterDIASCode: "A",
  },
  ANTIGUA_AND_BARBUDA: {
    fullName: "Antigua and Barbuda",
    twoLetterISOCode: "AG",
    oneLetterDIASCode: "A",
  },
  ARGENTINA: {
    fullName: "Argentina",
    twoLetterISOCode: "AR",
    oneLetterDIASCode: "A",
  },
  ARMENIA: {
    fullName: "Armenia",
    twoLetterISOCode: "AM",
    oneLetterDIASCode: "A",
  },
  ARUBA: {
    fullName: "Aruba",
    twoLetterISOCode: "AW",
    oneLetterDIASCode: "A",
  },
  AUSTRALIA: {
    fullName: "Australia",
    twoLetterISOCode: "AU",
    oneLetterDIASCode: "A",
  },
  AUSTRIA: {
    fullName: "Austria",
    twoLetterISOCode: "AT",
    oneLetterDIASCode: "A",
  },
  AZERBAIJAN: {
    fullName: "Azerbaijan",
    twoLetterISOCode: "AZ",
    oneLetterDIASCode: "A",
  },
  BAHAMAS: {
    fullName: "Bahamas",
    twoLetterISOCode: "BS",
    oneLetterDIASCode: "B",
  },
  BAHRAIN: {
    fullName: "Bahrain",
    twoLetterISOCode: "BH",
    oneLetterDIASCode: "B",
  },
  BANGLADESH: {
    fullName: "Bangladesh",
    twoLetterISOCode: "BD",
    oneLetterDIASCode: "B",
  },
  BARBADOS: {
    fullName: "Barbados",
    twoLetterISOCode: "BB",
    oneLetterDIASCode: "B",
  },
  BELARUS: {
    fullName: "Belarus",
    twoLetterISOCode: "BY",
    oneLetterDIASCode: "B",
  },
  BELGIUM: {
    fullName: "Belgium",
    twoLetterISOCode: "BE",
    oneLetterDIASCode: "B",
  },
  BELIZE: {
    fullName: "Belize",
    twoLetterISOCode: "BZ",
    oneLetterDIASCode: "B",
  },
  BENIN: {
    fullName: "Benin",
    twoLetterISOCode: "BJ",
    oneLetterDIASCode: "B",
  },
  BERMUDA: {
    fullName: "Bermuda",
    twoLetterISOCode: "BM",
    oneLetterDIASCode: "B",
  },
  BHUTAN: {
    fullName: "Bhutan",
    twoLetterISOCode: "BT",
    oneLetterDIASCode: "B",
  },
  BOLIVIA: {
    fullName: "Bolivia",
    twoLetterISOCode: "BO",
    oneLetterDIASCode: "B",
  },
  BOSNIA_AND_HERZEGOVINA: {
    fullName: "Bosnia and Herzegovina",
    twoLetterISOCode: "BA",
    oneLetterDIASCode: "B",
  },
  BOTSWANA: {
    fullName: "Botswana",
    twoLetterISOCode: "BW",
    oneLetterDIASCode: "B",
  },
  BOUVET_ISLAND: {
    fullName: "Bouvet Island",
    twoLetterISOCode: "BV",
    oneLetterDIASCode: "B",
  },
  BRAZIL: {
    fullName: "Brazil",
    twoLetterISOCode: "BR",
    oneLetterDIASCode: "B",
  },
  BRITISH_INDIAN_OCEAN_TERRITORY: {
    fullName: "British Indian Ocean Territory",
    twoLetterISOCode: "IO",
    oneLetterDIASCode: "B",
  },
  BRUNEI_DARUSSALAM: {
    fullName: "Brunei Darussalam",
    twoLetterISOCode: "BN",
    oneLetterDIASCode: "B",
  },
  BULGARIA: {
    fullName: "Bulgaria",
    twoLetterISOCode: "BG",
    oneLetterDIASCode: "B",
  },
  BURKINA_FASO: {
    fullName: "Burkina Faso",
    twoLetterISOCode: "BF",
    oneLetterDIASCode: "B",
  },
  BURUNDI: {
    fullName: "Burundi",
    twoLetterISOCode: "BI",
    oneLetterDIASCode: "B",
  },
  CAMBODIA: {
    fullName: "Cambodia",
    twoLetterISOCode: "KH",
    oneLetterDIASCode: "C",
  },
  CAMEROON: {
    fullName: "Cameroon",
    twoLetterISOCode: "CM",
    oneLetterDIASCode: "C",
  },
  CANADA: {
    fullName: "Canada",
    twoLetterISOCode: "CA",
    oneLetterDIASCode: "C",
  },
  CAPE_VERDE: {
    fullName: "Cape Verde",
    twoLetterISOCode: "CV",
    oneLetterDIASCode: "C",
  },
  CAYMAN_ISLANDS: {
    fullName: "Cayman Islands",
    twoLetterISOCode: "KY",
    oneLetterDIASCode: "C",
  },
  CENTRAL_AFRICAN_REPUBLIC: {
    fullName: "Central African Republic",
    twoLetterISOCode: "CF",
    oneLetterDIASCode: "C",
  },
  CHAD: {
    fullName: "Chad",
    twoLetterISOCode: "TD",
    oneLetterDIASCode: "C",
  },
  CHILE: {
    fullName: "Chile",
    twoLetterISOCode: "CL",
    oneLetterDIASCode: "C",
  },
  CHINA: {
    fullName: "China",
    twoLetterISOCode: "CN",
    oneLetterDIASCode: "C",
  },
  CHRISTMAS_ISLAND: {
    fullName: "Christmas Island",
    twoLetterISOCode: "CX",
    oneLetterDIASCode: "C",
  },
  COCOS_KEELING_ISLANDS: {
    fullName: "Cocos (Keeling) Islands",
    twoLetterISOCode: "CC",
    oneLetterDIASCode: "C",
  },
  COLOMBIA: {
    fullName: "Colombia",
    twoLetterISOCode: "CO",
    oneLetterDIASCode: "C",
  },
  COMOROS: {
    fullName: "Comoros",
    twoLetterISOCode: "KM",
    oneLetterDIASCode: "C",
  },
  CONGO: {
    fullName: "Congo",
    twoLetterISOCode: "CG",
    oneLetterDIASCode: "C",
  },
  CONGO_DEMOCRATIC_REPUBLIC: {
    fullName: "Congo, The Democratic Republic of the",
    twoLetterISOCode: "CD",
    oneLetterDIASCode: "C",
  },
  COOK_ISLANDS: {
    fullName: "Cook Islands",
    twoLetterISOCode: "CK",
    oneLetterDIASCode: "C",
  },
  COSTA_RICA: {
    fullName: "Costa Rica",
    twoLetterISOCode: "CR",
    oneLetterDIASCode: "C",
  },
  COTE_DIVOIRE: {
    fullName: "Cote D'Ivoire",
    twoLetterISOCode: "CI",
    oneLetterDIASCode: "C",
  },
  CROATIA: {
    fullName: "Croatia",
    twoLetterISOCode: "HR",
    oneLetterDIASCode: "C",
  },
  CUBA: {
    fullName: "Cuba",
    twoLetterISOCode: "CU",
    oneLetterDIASCode: "C",
  },
  CYPRUS: {
    fullName: "Cyprus",
    twoLetterISOCode: "CY",
    oneLetterDIASCode: "C",
  },
  CZECH_REPUBLIC: {
    fullName: "Czech Republic",
    twoLetterISOCode: "CZ",
    oneLetterDIASCode: "C",
  },
  DENMARK: {
    fullName: "Denmark",
    twoLetterISOCode: "DK",
    oneLetterDIASCode: "D",
  },
  DJIBOUTI: {
    fullName: "Djibouti",
    twoLetterISOCode: "DJ",
    oneLetterDIASCode: "D",
  },
  DOMINICA: {
    fullName: "Dominica",
    twoLetterISOCode: "DM",
    oneLetterDIASCode: "D",
  },
  DOMINICAN_REPUBLIC: {
    fullName: "Dominican Republic",
    twoLetterISOCode: "DO",
    oneLetterDIASCode: "D",
  },
  ECUADOR: {
    fullName: "Ecuador",
    twoLetterISOCode: "EC",
    oneLetterDIASCode: "E",
  },
  EGYPT: {
    fullName: "Egypt",
    twoLetterISOCode: "EG",
    oneLetterDIASCode: "E",
  },
  EL_SALVADOR: {
    fullName: "El Salvador",
    twoLetterISOCode: "SV",
    oneLetterDIASCode: "E",
  },
  EQUATORIAL_GUINEA: {
    fullName: "Equatorial Guinea",
    twoLetterISOCode: "GQ",
    oneLetterDIASCode: "E",
  },
  ERITREA: {
    fullName: "Eritrea",
    twoLetterISOCode: "ER",
    oneLetterDIASCode: "E",
  },
  ESTONIA: {
    fullName: "Estonia",
    twoLetterISOCode: "EE",
    oneLetterDIASCode: "E",
  },
  ETHIOPIA: {
    fullName: "Ethiopia",
    twoLetterISOCode: "ET",
    oneLetterDIASCode: "E",
  },
  FALKLAND_ISLANDS: {
    fullName: "Falkland Islands (Malvinas)",
    twoLetterISOCode: "FK",
    oneLetterDIASCode: "F",
  },
  FAROE_ISLANDS: {
    fullName: "Faroe Islands",
    twoLetterISOCode: "FO",
    oneLetterDIASCode: "F",
  },
  FIJI: {
    fullName: "Fiji",
    twoLetterISOCode: "FJ",
    oneLetterDIASCode: "F",
  },
  FINLAND: {
    fullName: "Finland",
    twoLetterISOCode: "FI",
    oneLetterDIASCode: "F",
  },
  FRANCE: {
    fullName: "France",
    twoLetterISOCode: "FR",
    oneLetterDIASCode: "F",
  },
  FRENCH_GUIANA: {
    fullName: "French Guiana",
    twoLetterISOCode: "GF",
    oneLetterDIASCode: "F",
  },
  FRENCH_POLYNESIA: {
    fullName: "French Polynesia",
    twoLetterISOCode: "PF",
    oneLetterDIASCode: "F",
  },
  FRENCH_SOUTHERN_TERRITORIES: {
    fullName: "French Southern Territories",
    twoLetterISOCode: "TF",
    oneLetterDIASCode: "F",
  },
  GABON: {
    fullName: "Gabon",
    twoLetterISOCode: "GA",
    oneLetterDIASCode: "G",
  },
  GAMBIA: {
    fullName: "Gambia",
    twoLetterISOCode: "GM",
    oneLetterDIASCode: "G",
  },
  GEORGIA: {
    fullName: "Georgia",
    twoLetterISOCode: "GE",
    oneLetterDIASCode: "G",
  },
  GERMANY: {
    fullName: "Germany",
    twoLetterISOCode: "DE",
    oneLetterDIASCode: "G",
  },
  GHANA: {
    fullName: "Ghana",
    twoLetterISOCode: "GH",
    oneLetterDIASCode: "G",
  },
  GIBRALTAR: {
    fullName: "Gibraltar",
    twoLetterISOCode: "GI",
    oneLetterDIASCode: "G",
  },
  GREECE: {
    fullName: "Greece",
    twoLetterISOCode: "GR",
    oneLetterDIASCode: "G",
  },
  GREENLAND: {
    fullName: "Greenland",
    twoLetterISOCode: "GL",
    oneLetterDIASCode: "G",
  },
  GRENADA: {
    fullName: "Grenada",
    twoLetterISOCode: "GD",
    oneLetterDIASCode: "G",
  },
  GUADELOUPE: {
    fullName: "Guadeloupe",
    twoLetterISOCode: "GP",
    oneLetterDIASCode: "G",
  },
  GUAM: {
    fullName: "Guam",
    twoLetterISOCode: "GU",
    oneLetterDIASCode: "G",
  },
  GUATEMALA: {
    fullName: "Guatemala",
    twoLetterISOCode: "GT",
    oneLetterDIASCode: "G",
  },
  GUERNSEY: {
    fullName: "Guernsey",
    twoLetterISOCode: "GG",
    oneLetterDIASCode: "G",
  },
  GUINEA: {
    fullName: "Guinea",
    twoLetterISOCode: "GN",
    oneLetterDIASCode: "G",
  },
  GUINEA_BISSAU: {
    fullName: "Guinea-Bissau",
    twoLetterISOCode: "GW",
    oneLetterDIASCode: "G",
  },
  GUYANA: {
    fullName: "Guyana",
    twoLetterISOCode: "GY",
    oneLetterDIASCode: "G",
  },
  HAITI: {
    fullName: "Haiti",
    twoLetterISOCode: "HT",
    oneLetterDIASCode: "H",
  },
  HEARD_ISLAND: {
    fullName: "Heard Island and Mcdonald Islands",
    twoLetterISOCode: "HM",
    oneLetterDIASCode: "H",
  },
  HOLY_SEE: {
    fullName: "Holy See (Vatican City State)",
    twoLetterISOCode: "VA",
    oneLetterDIASCode: "H",
  },
  HONDURAS: {
    fullName: "Honduras",
    twoLetterISOCode: "HN",
    oneLetterDIASCode: "H",
  },
  HONG_KONG: {
    fullName: "Hong Kong",
    twoLetterISOCode: "HK",
    oneLetterDIASCode: "H",
  },
  HUNGARY: {
    fullName: "Hungary",
    twoLetterISOCode: "HU",
    oneLetterDIASCode: "H",
  },
  ICELAND: {
    fullName: "Iceland",
    twoLetterISOCode: "IS",
    oneLetterDIASCode: "I",
  },
  INDIA: {
    fullName: "India",
    twoLetterISOCode: "IN",
    oneLetterDIASCode: "I",
  },
  INDONESIA: {
    fullName: "Indonesia",
    twoLetterISOCode: "ID",
    oneLetterDIASCode: "I",
  },
  IRAN: {
    fullName: "Iran, Islamic Republic Of",
    twoLetterISOCode: "IR",
    oneLetterDIASCode: "I",
  },
  IRAQ: {
    fullName: "Iraq",
    twoLetterISOCode: "IQ",
    oneLetterDIASCode: "I",
  },
  IRELAND: {
    fullName: "Ireland",
    twoLetterISOCode: "IE",
    oneLetterDIASCode: "I",
  },
  ISLE_OF_MAN: {
    fullName: "Isle of Man",
    twoLetterISOCode: "IM",
    oneLetterDIASCode: "I",
  },
  ISRAEL: {
    fullName: "Israel",
    twoLetterISOCode: "IL",
    oneLetterDIASCode: "I",
  },
  ITALY: {
    fullName: "Italy",
    twoLetterISOCode: "IT",
    oneLetterDIASCode: "I",
  },
  JAMAICA: {
    fullName: "Jamaica",
    twoLetterISOCode: "JM",
    oneLetterDIASCode: "J",
  },
  JAPAN: {
    fullName: "Japan",
    twoLetterISOCode: "JP",
    oneLetterDIASCode: "J",
  },
  JERSEY: {
    fullName: "Jersey",
    twoLetterISOCode: "JE",
    oneLetterDIASCode: "J",
  },
  JORDAN: {
    fullName: "Jordan",
    twoLetterISOCode: "JO",
    oneLetterDIASCode: "J",
  },
  KAZAKHSTAN: {
    fullName: "Kazakhstan",
    twoLetterISOCode: "KZ",
    oneLetterDIASCode: "K",
  },
  KENYA: {
    fullName: "Kenya",
    twoLetterISOCode: "KE",
    oneLetterDIASCode: "K",
  },
  KIRIBATI: {
    fullName: "Kiribati",
    twoLetterISOCode: "KI",
    oneLetterDIASCode: "K",
  },
  KOREA_DEMOCRATIC_PEOPLES_REPUBLIC: {
    fullName: "Korea, Democratic People'S Republic of",
    twoLetterISOCode: "KP",
    oneLetterDIASCode: "K",
  },
  KOREA_REPUBLIC: {
    fullName: "Korea, Republic of",
    twoLetterISOCode: "KR",
    oneLetterDIASCode: "K",
  },
  KUWAIT: {
    fullName: "Kuwait",
    twoLetterISOCode: "KW",
    oneLetterDIASCode: "K",
  },
  KYRGYZSTAN: {
    fullName: "Kyrgyzstan",
    twoLetterISOCode: "KG",
    oneLetterDIASCode: "K",
  },
  LAO_PEOPLES_DEMOCRATIC_REPUBLIC: {
    fullName: "Lao People'S Democratic Republic",
    twoLetterISOCode: "LA",
    oneLetterDIASCode: "L",
  },
  LATVIA: {
    fullName: "Latvia",
    twoLetterISOCode: "LV",
    oneLetterDIASCode: "L",
  },
  LEBANON: {
    fullName: "Lebanon",
    twoLetterISOCode: "LB",
    oneLetterDIASCode: "L",
  },
  LESOTHO: {
    fullName: "Lesotho",
    twoLetterISOCode: "LS",
    oneLetterDIASCode: "L",
  },
  LIBERIA: {
    fullName: "Liberia",
    twoLetterISOCode: "LR",
    oneLetterDIASCode: "L",
  },
  LIBYAN_ARAB_JAMAHIRIYA: {
    fullName: "Libyan Arab Jamahiriya",
    twoLetterISOCode: "LY",
    oneLetterDIASCode: "L",
  },
  LIECHTENSTEIN: {
    fullName: "Liechtenstein",
    twoLetterISOCode: "LI",
    oneLetterDIASCode: "L",
  },
  LITHUANIA: {
    fullName: "Lithuania",
    twoLetterISOCode: "LT",
    oneLetterDIASCode: "L",
  },
  LUXEMBOURG: {
    fullName: "Luxembourg",
    twoLetterISOCode: "LU",
    oneLetterDIASCode: "L",
  },
  MACAO: {
    fullName: "Macao",
    twoLetterISOCode: "MO",
    oneLetterDIASCode: "M",
  },
  MACEDONIA: {
    fullName: "Macedonia, The Former Yugoslav Republic of",
    twoLetterISOCode: "MK",
    oneLetterDIASCode: "M",
  },
  MADAGASCAR: {
    fullName: "Madagascar",
    twoLetterISOCode: "MG",
    oneLetterDIASCode: "M",
  },
  MALAWI: {
    fullName: "Malawi",
    twoLetterISOCode: "MW",
    oneLetterDIASCode: "M",
  },
  MALAYSIA: {
    fullName: "Malaysia",
    twoLetterISOCode: "MY",
    oneLetterDIASCode: "M",
  },
  MALDIVES: {
    fullName: "Maldives",
    twoLetterISOCode: "MV",
    oneLetterDIASCode: "M",
  },
  MALI: {
    fullName: "Mali",
    twoLetterISOCode: "ML",
    oneLetterDIASCode: "M",
  },
  MALTA: {
    fullName: "Malta",
    twoLetterISOCode: "MT",
    oneLetterDIASCode: "M",
  },
  MARSHALL_ISLANDS: {
    fullName: "Marshall Islands",
    twoLetterISOCode: "MH",
    oneLetterDIASCode: "M",
  },
  MARTINIQUE: {
    fullName: "Martinique",
    twoLetterISOCode: "MQ",
    oneLetterDIASCode: "M",
  },
  MAURITANIA: {
    fullName: "Mauritania",
    twoLetterISOCode: "MR",
    oneLetterDIASCode: "M",
  },
  MAURITIUS: {
    fullName: "Mauritius",
    twoLetterISOCode: "MU",
    oneLetterDIASCode: "M",
  },
  MAYOTTE: {
    fullName: "Mayotte",
    twoLetterISOCode: "YT",
    oneLetterDIASCode: "M",
  },
  MEXICO: {
    fullName: "Mexico",
    twoLetterISOCode: "MX",
    oneLetterDIASCode: "M",
  },
  MICRONESIA: {
    fullName: "Micronesia, Federated States of",
    twoLetterISOCode: "FM",
    oneLetterDIASCode: "M",
  },
  MOLDOVA: {
    fullName: "Moldova, Republic of",
    twoLetterISOCode: "MD",
    oneLetterDIASCode: "M",
  },
  MONACO: {
    fullName: "Monaco",
    twoLetterISOCode: "MC",
    oneLetterDIASCode: "M",
  },
  MONGOLIA: {
    fullName: "Mongolia",
    twoLetterISOCode: "MN",
    oneLetterDIASCode: "M",
  },
  MONTSERRAT: {
    fullName: "Montserrat",
    twoLetterISOCode: "MS",
    oneLetterDIASCode: "M",
  },
  MOROCCO: {
    fullName: "Morocco",
    twoLetterISOCode: "MA",
    oneLetterDIASCode: "M",
  },
  MOZAMBIQUE: {
    fullName: "Mozambique",
    twoLetterISOCode: "MZ",
    oneLetterDIASCode: "M",
  },
  MYANMAR: {
    fullName: "Myanmar",
    twoLetterISOCode: "MM",
    oneLetterDIASCode: "M",
  },
  NAMIBIA: {
    fullName: "Namibia",
    twoLetterISOCode: "NA",
    oneLetterDIASCode: "N",
  },
  NAURU: {
    fullName: "Nauru",
    twoLetterISOCode: "NR",
    oneLetterDIASCode: "N",
  },
  NEPAL: {
    fullName: "Nepal",
    twoLetterISOCode: "NP",
    oneLetterDIASCode: "N",
  },
  NETHERLANDS: {
    fullName: "Netherlands",
    twoLetterISOCode: "NL",
    oneLetterDIASCode: "N",
  },
  NETHERLANDS_ANTILLES: {
    fullName: "Netherlands Antilles",
    twoLetterISOCode: "AN",
    oneLetterDIASCode: "N",
  },
  NEW_CALEDONIA: {
    fullName: "New Caledonia",
    twoLetterISOCode: "NC",
    oneLetterDIASCode: "N",
  },
  NEW_ZEALAND: {
    fullName: "New Zealand",
    twoLetterISOCode: "NZ",
    oneLetterDIASCode: "N",
  },
  NICARAGUA: {
    fullName: "Nicaragua",
    twoLetterISOCode: "NI",
    oneLetterDIASCode: "N",
  },
  NIGER: {
    fullName: "Niger",
    twoLetterISOCode: "NE",
    oneLetterDIASCode: "N",
  },
  NIGERIA: {
    fullName: "Nigeria",
    twoLetterISOCode: "NG",
    oneLetterDIASCode: "N",
  },
  NIUE: {
    fullName: "Niue",
    twoLetterISOCode: "NU",
    oneLetterDIASCode: "N",
  },
  NORFOLK_ISLAND: {
    fullName: "Norfolk Island",
    twoLetterISOCode: "NF",
    oneLetterDIASCode: "N",
  },
  NORTHERN_MARIANA_ISLANDS: {
    fullName: "Northern Mariana Islands",
    twoLetterISOCode: "MP",
    oneLetterDIASCode: "N",
  },
  NORWAY: {
    fullName: "Norway",
    twoLetterISOCode: "NO",
    oneLetterDIASCode: "N",
  },
  OMAN: {
    fullName: "Oman",
    twoLetterISOCode: "OM",
    oneLetterDIASCode: "O",
  },
  PAKISTAN: {
    fullName: "Pakistan",
    twoLetterISOCode: "PK",
    oneLetterDIASCode: "P",
  },
  PALAU: {
    fullName: "Palau",
    twoLetterISOCode: "PW",
    oneLetterDIASCode: "P",
  },
  PALESTINIAN_TERRITORY: {
    fullName: "Palestinian Territory, Occupied",
    twoLetterISOCode: "PS",
    oneLetterDIASCode: "P",
  },
  PANAMA: {
    fullName: "Panama",
    twoLetterISOCode: "PA",
    oneLetterDIASCode: "P",
  },
  PAPUA_NEW_GUINEA: {
    fullName: "Papua New Guinea",
    twoLetterISOCode: "PG",
    oneLetterDIASCode: "P",
  },
  PARAGUAY: {
    fullName: "Paraguay",
    twoLetterISOCode: "PY",
    oneLetterDIASCode: "P",
  },
  PERU: {
    fullName: "Peru",
    twoLetterISOCode: "PE",
    oneLetterDIASCode: "P",
  },
  PHILIPPINES: {
    fullName: "Philippines",
    twoLetterISOCode: "PH",
    oneLetterDIASCode: "P",
  },
  PITCAIRN: {
    fullName: "Pitcairn",
    twoLetterISOCode: "PN",
    oneLetterDIASCode: "P",
  },
  POLAND: {
    fullName: "Poland",
    twoLetterISOCode: "PL",
    oneLetterDIASCode: "P",
  },
  PORTUGAL: {
    fullName: "Portugal",
    twoLetterISOCode: "PT",
    oneLetterDIASCode: "P",
  },
  PUERTO_RICO: {
    fullName: "Puerto Rico",
    twoLetterISOCode: "PR",
    oneLetterDIASCode: "P",
  },
  QATAR: {
    fullName: "Qatar",
    twoLetterISOCode: "QA",
    oneLetterDIASCode: "Q",
  },
  REUNION: {
    fullName: "Reunion",
    twoLetterISOCode: "RE",
    oneLetterDIASCode: "R",
  },
  ROMANIA: {
    fullName: "Romania",
    twoLetterISOCode: "RO",
    oneLetterDIASCode: "R",
  },
  RUSSIAN_FEDERATION: {
    fullName: "Russian Federation",
    twoLetterISOCode: "RU",
    oneLetterDIASCode: "R",
  },
  RWANDA: {
    fullName: "RWANDA",
    twoLetterISOCode: "RW",
    oneLetterDIASCode: "R",
  },
  SAINT_HELENA: {
    fullName: "Saint Helena",
    twoLetterISOCode: "SH",
    oneLetterDIASCode: "S",
  },
  SAINT_KITTS_AND_NEVIS: {
    fullName: "Saint Kitts and Nevis",
    twoLetterISOCode: "KN",
    oneLetterDIASCode: "S",
  },
  SAINT_LUCIA: {
    fullName: "Saint Lucia",
    twoLetterISOCode: "LC",
    oneLetterDIASCode: "S",
  },
  SAINT_PIERRE_AND_MIQUELON: {
    fullName: "Saint Pierre and Miquelon",
    twoLetterISOCode: "PM",
    oneLetterDIASCode: "S",
  },
  SAINT_VINCENT_AND_THE_GRENADINES: {
    fullName: "Saint Vincent and the Grenadines",
    twoLetterISOCode: "VC",
    oneLetterDIASCode: "S",
  },
  SAMOA: {
    fullName: "Samoa",
    twoLetterISOCode: "WS",
    oneLetterDIASCode: "S",
  },
  SAN_MARINO: {
    fullName: "San Marino",
    twoLetterISOCode: "SM",
    oneLetterDIASCode: "S",
  },
  SAO_TOME_AND_PRINCIPE: {
    fullName: "Sao Tome and Principe",
    twoLetterISOCode: "ST",
    oneLetterDIASCode: "S",
  },
  SAUDI_ARABIA: {
    fullName: "Saudi Arabia",
    twoLetterISOCode: "SA",
    oneLetterDIASCode: "S",
  },
  SENEGAL: {
    fullName: "Senegal",
    twoLetterISOCode: "SN",
    oneLetterDIASCode: "S",
  },
  SERBIA_AND_MONTENEGRO: {
    fullName: "Serbia and Montenegro",
    twoLetterISOCode: "CS",
    oneLetterDIASCode: "S",
  },
  SEYCHELLES: {
    fullName: "Seychelles",
    twoLetterISOCode: "SC",
    oneLetterDIASCode: "S",
  },
  SIERRA_LEONE: {
    fullName: "Sierra Leone",
    twoLetterISOCode: "SL",
    oneLetterDIASCode: "S",
  },
  SINGAPORE: {
    fullName: "Singapore",
    twoLetterISOCode: "SG",
    oneLetterDIASCode: "S",
  },
  SLOVAKIA: {
    fullName: "Slovakia",
    twoLetterISOCode: "SK",
    oneLetterDIASCode: "S",
  },
  SLOVENIA: {
    fullName: "Slovenia",
    twoLetterISOCode: "SI",
    oneLetterDIASCode: "S",
  },
  SOLOMON_ISLANDS: {
    fullName: "Solomon Islands",
    twoLetterISOCode: "SB",
    oneLetterDIASCode: "S",
  },
  SOMALIA: {
    fullName: "Somalia",
    twoLetterISOCode: "SO",
    oneLetterDIASCode: "S",
  },
  SOUTH_AFRICA: {
    fullName: "South Africa",
    twoLetterISOCode: "ZA",
    oneLetterDIASCode: "S",
  },
  SOUTH_GEORGIA: {
    fullName: "South Georgia and the South Sandwich Islands",
    twoLetterISOCode: "GS",
    oneLetterDIASCode: "S",
  },
  SPAIN: {
    fullName: "Spain",
    twoLetterISOCode: "ES",
    oneLetterDIASCode: "S",
  },
  SRI_LANKA: {
    fullName: "Sri Lanka",
    twoLetterISOCode: "LK",
    oneLetterDIASCode: "S",
  },
  SUDAN: {
    fullName: "Sudan",
    twoLetterISOCode: "SD",
    oneLetterDIASCode: "S",
  },
  SURINAME: {
    fullName: "Suriname",
    twoLetterISOCode: "SR",
    oneLetterDIASCode: "S",
  },
  SVALBARD_AND_JAN_MAYEN: {
    fullName: "Svalbard and Jan Mayen",
    twoLetterISOCode: "SJ",
    oneLetterDIASCode: "S",
  },
  SWAZILAND: {
    fullName: "Swaziland",
    twoLetterISOCode: "SZ",
    oneLetterDIASCode: "S",
  },
  SWEDEN: {
    fullName: "Sweden",
    twoLetterISOCode: "SE",
    oneLetterDIASCode: "S",
  },
  SWITZERLAND: {
    fullName: "Switzerland",
    twoLetterISOCode: "CH",
    oneLetterDIASCode: "S",
  },
  SYRIAN_ARAB_REPUBLIC: {
    fullName: "Syrian Arab Republic",
    twoLetterISOCode: "SY",
    oneLetterDIASCode: "S",
  },
  TAIWAN: {
    fullName: "Taiwan, Province of China",
    twoLetterISOCode: "TW",
    oneLetterDIASCode: "T",
  },
  TAJIKISTAN: {
    fullName: "Tajikistan",
    twoLetterISOCode: "TJ",
    oneLetterDIASCode: "T",
  },
  TANZANIA: {
    fullName: "Tanzania, United Republic of",
    twoLetterISOCode: "TZ",
    oneLetterDIASCode: "T",
  },
  THAILAND: {
    fullName: "Thailand",
    twoLetterISOCode: "TH",
    oneLetterDIASCode: "T",
  },
  TIMOR_LESTE: {
    fullName: "Timor-Leste",
    twoLetterISOCode: "TL",
    oneLetterDIASCode: "T",
  },
  TOGO: {
    fullName: "Togo",
    twoLetterISOCode: "TG",
    oneLetterDIASCode: "T",
  },
  TOKELAU: {
    fullName: "Tokelau",
    twoLetterISOCode: "TK",
    oneLetterDIASCode: "T",
  },
  TONGA: {
    fullName: "Tonga",
    twoLetterISOCode: "TO",
    oneLetterDIASCode: "T",
  },
  TRINIDAD_AND_TOBAGO: {
    fullName: "Trinidad and Tobago",
    twoLetterISOCode: "TT",
    oneLetterDIASCode: "T",
  },
  TUNISIA: {
    fullName: "Tunisia",
    twoLetterISOCode: "TN",
    oneLetterDIASCode: "T",
  },
  TURKEY: {
    fullName: "Turkey",
    twoLetterISOCode: "TR",
    oneLetterDIASCode: "T",
  },
  TURKMENISTAN: {
    fullName: "Turkmenistan",
    twoLetterISOCode: "TM",
    oneLetterDIASCode: "T",
  },
  TURKS_AND_CAICOS_ISLANDS: {
    fullName: "Turks and Caicos Islands",
    twoLetterISOCode: "TC",
    oneLetterDIASCode: "T",
  },
  TUVALU: {
    fullName: "Tuvalu",
    twoLetterISOCode: "TV",
    oneLetterDIASCode: "T",
  },
  UGANDA: {
    fullName: "Uganda",
    twoLetterISOCode: "UG",
    oneLetterDIASCode: "U",
  },
  UKRAINE: {
    fullName: "Ukraine",
    twoLetterISOCode: "UA",
    oneLetterDIASCode: "U",
  },
  UNITED_ARAB_EMIRATES: {
    fullName: "United Arab Emirates",
    twoLetterISOCode: "AE",
    oneLetterDIASCode: "U",
  },
  UNITED_KINGDOM: {
    fullName: "United Kingdom",
    twoLetterISOCode: "GB",
    oneLetterDIASCode: "U",
  },
  UNITED_STATES: {
    fullName: "United States",
    twoLetterISOCode: "US",
    oneLetterDIASCode: "U",
  },
  UNITED_STATES_MINOR_OUTLYING_ISLANDS: {
    fullName: "United States Minor Outlying Islands",
    twoLetterISOCode: "UM",
    oneLetterDIASCode: "U",
  },
  URUGUAY: {
    fullName: "Uruguay",
    twoLetterISOCode: "UY",
    oneLetterDIASCode: "U",
  },
  UZBEKISTAN: {
    fullName: "Uzbekistan",
    twoLetterISOCode: "UZ",
    oneLetterDIASCode: "U",
  },
  VANUATU: {
    fullName: "Vanuatu",
    twoLetterISOCode: "VU",
    oneLetterDIASCode: "V",
  },
  VENEZUELA: {
    fullName: "Venezuela",
    twoLetterISOCode: "VE",
    oneLetterDIASCode: "V",
  },
  VIET_NAM: {
    fullName: "Viet Nam",
    twoLetterISOCode: "VN",
    oneLetterDIASCode: "V",
  },
  VIRGIN_ISLANDS_BRITISH: {
    fullName: "Virgin Islands, British",
    twoLetterISOCode: "VG",
    oneLetterDIASCode: "V",
  },
  VIRGIN_ISLANDS_US: {
    fullName: "Virgin Islands, U.S.",
    twoLetterISOCode: "VI",
    oneLetterDIASCode: "V",
  },
  WALLIS_AND_FUTUNA: {
    fullName: "Wallis and Futuna",
    twoLetterISOCode: "WF",
    oneLetterDIASCode: "W",
  },
  WESTERN_SAHARA: {
    fullName: "Western Sahara",
    twoLetterISOCode: "EH",
    oneLetterDIASCode: "W",
  },
  YEMEN: {
    fullName: "Yemen",
    twoLetterISOCode: "YE",
    oneLetterDIASCode: "Y",
  },
  ZAMBIA: {
    fullName: "Zambia",
    twoLetterISOCode: "ZM",
    oneLetterDIASCode: "Z",
  },
  ZIMBABWE: {
    fullName: "Zimbabwe",
    twoLetterISOCode: "ZW",
    oneLetterDIASCode: "Z",
  },
};


const getCountryIsoTwoFromAnyCode = (code) => {
  return Object.entries(DELIVERY_COUNTRY).find(
    ([key, value]) => value.iso2 === code || value.iso3 === code || value.sourceCode === code
  )[1].iso2;
};

const getCountryFullNameFromAnyCode = (twoLetterISOCode) => {
  const code = getCountryIsoTwoFromAnyCode(twoLetterISOCode)
  return Object.entries(DELIVERY_COUNTRY).find(
    ([key, value]) => value.iso2 === code
  )[1].fullName;
};

module.exports = {
  DELIVERY_COUNTRY,
  ALLOWED_COUNTRIES_FOR_REGISTRATION_BY_ISO2,
  ALL_COUNTRIES,
  getCountryIsoTwoFromAnyCode,
  getCountryFullNameFromAnyCode,
};
